<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-3">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-9 align-self-center">
                <div class="text-lg-center mt-4 mt-lg-0">
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          {{ $t("user-management.total-user") }}
                        </p>
                        <h4 class="mb-0">
                          {{ total_user }}
                        </h4>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          {{ $t("user-management.online-user") }}
                        </p>
                        <h4 class="mb-0">
                          {{ online_user }}
                        </h4>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          {{ $t("user-management.active-user") }}
                        </p>
                        <h4 class="mb-0">
                          {{ active_user }}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 d-none d-lg-block text-right">
                <div class="mt-4 mt-lg-0">
                  <router-link to="/user-grafik">
                    <b-button class="btn" variant="light">
                      Detail Statistik
                    </b-button>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-xs-12 d-none d-sm-block">
                <h5 class="mt-2">{{ $t("user-management.list-user") }}</h5>
              </div>
              <div class="col-md-6 col-xs-12 text-right">
                <b-button
                  @click="getUser"
                  variant="outline-success"
                  size="sm"
                  class="btn btn-sm mr-1 p-1 px-2"
                  style=""
                >
                  <i
                    class="mdi mdi-refresh mdi-16px"
                    :class="loading ? 'mdi-spin' : ''"
                  ></i>
                </b-button>
                <b-button
                  @click="addUserModal"
                  variant="success"
                  size="sm"
                  class="btn mr-1"
                >
                  {{ $t("button.add-user.text") }}
                  <i class="mdi mdi-plus mr-1"></i>
                </b-button>
              </div>
            </div>
            <b-modal
              id="modal-add"
              centered
              bordered
              :title="$t('button.add.text')"
              title-class="font-18"
              :ok-title="$t('button.save.text')"
              :cancel-title="$t('button.cancel.text')"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("user-management.phone")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      :placeholder="$t('user-management.phone-number')"
                      v-on:input="acceptNumber(form.user.address)"
                      v-model="form.user.address"
                      :class="{
                        'is-invalid': submitted && $v.form.user.address.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.address.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.address.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("user-management.name")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      :placeholder="$t('user-management.name')"
                      v-model="form.user.name"
                      :class="{
                        'is-invalid': submitted && $v.form.user.name.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.name.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("user-management.description")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      :placeholder="$t('user-management.description')"
                      v-model="form.user.description"
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">NRP</label>
                    <input
                      id="validationCustom01"
                      type="number"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.form.user.nrp.$error,
                      }"
                      placeholder="nrp"
                      v-model="form.user.nrp"
                    />
                    <div
                      v-if="submitted && $v.form.user.nrp.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.nrp.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12" v-if="user_type == 'superadmin'">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("departments.department")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="form.user.id_dep"
                      :class="{
                        'is-invalid': submitted && $v.form.user.id_dep.$error,
                      }"
                    >
                      <option
                        v-for="rg in tableDataDapertement"
                        :key="rg.id_dep"
                        :value="rg.id_dep"
                      >
                        {{ rg.dep_name }}
                      </option>
                    </select>
                    <div
                      v-if="submitted && $v.form.user.id_dep.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.id_dep.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <template #modal-footer="{ cancel }">
                <b-button
                  size="md"
                  variant="danger"
                  @click="cancel()"
                  :class="{ 'disabled ': loading_add }"
                >
                  {{ $t("button.cancel.text") }}
                </b-button>
                <b-button
                  size="md"
                  variant="success"
                  @click="addUser"
                  :class="{ 'disabled ': loading_add }"
                >
                  <b-spinner
                    variant="light"
                    small
                    v-if="loading_add"
                  ></b-spinner>
                  {{ $t("button.save.text") }}
                </b-button>
              </template>
            </b-modal>
            <div class="row mt-5 mb-5 mx-auto" v-if="loading">
              <div class="col-12 p-5 m-4 text-center">
                <div
                  class="spinner-border text-secondary"
                  role="status"
                  v-if="loading"
                >
                  <span class="sr-only">Loading..</span>
                </div>
              </div>
            </div>
            <div v-if="!loading">
              <div class="row mt-4">
                <div class="col-md-6 col-xs-12">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mr-1">
                      <span class="mr-2"> {{ $t("tables.show") }}</span>
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                      <span class="ml-2">{{ $t("tables.entries") }}</span>
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-md-6 col-xs-12">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      {{ $t("tables.search") }}:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('tables.search')"
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData"
                  :fields="fields"
                  bordered
                  responsive="sm"
                  :hover="true"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(name)="row">
                    <div>
                      <span>{{
                        row.item.profile != null ? row.item.profile.name : "-"
                      }}</span>
                    </div>
                  </template>
                  <template #cell(ipaddress)="row">
                    <div>
                      <span>{{ ipconvert(row.item.ipaddr, false) }}</span>
                    </div>
                  </template>
                  <template #cell(lastonline)="row">
                    <div>
                      <span>{{
                        row.item.lastonline == 0
                          ? "-"
                          : formatDateTimes(row.item.lastonline)
                      }}</span>
                    </div>
                  </template>
                  <template #cell(online)="row">
                    <div>
                      <span
                        class="badge badge-pill badge-success px-2 py-1"
                        v-if="row.item.online == 1"
                      >
                        Online</span
                      >
                      <span
                        class="badge badge-pill badge-danger px-2 py-1"
                        v-if="row.item.online == 0"
                      >
                        Offline</span
                      >
                    </div>
                  </template>
                  <template #cell(action)="row">
                    <div>
                      <b-button
                        v-if="row.item.active"
                        size="sm"
                        variant="success"
                        class="mr-1 mb-1"
                        @click="setActive(row.item, 0)"
                        title="Deactivate"
                      >
                        <i
                          class="fas fa-circle-notch fa-spin"
                          v-if="
                            loading_active && row.item.uid == loading_active.id
                          "
                        ></i>
                        <i class="fas fa-user-check" v-else></i>
                      </b-button>
                      <b-button
                        v-if="!row.item.active"
                        size="sm"
                        variant="secondary"
                        class="mr-1 mb-1"
                        @click="setActive(row.item, 1)"
                        title="Activate"
                      >
                        <i
                          class="fas fa-circle-notch fa-spin"
                          v-if="
                            loading_active && row.item.uid == loading_active.id
                          "
                        ></i>
                        <i class="fas fa-user-times" v-else></i>
                      </b-button>

                      <router-link :to="'/user/detail/' + row.item.uid">
                        <b-button size="sm" variant="info" class="mr-1 mb-1"
                          ><i class="fas fa-eye"></i></b-button
                      ></router-link>
                      <b-dropdown
                        class="card-drop mb-1"
                        variant="light"
                        right
                        toggle-class="p-0"
                      >
                        <template v-slot:button-content>
                          <i
                            class="mdi mdi-dots-horizontal font-size-18 px-1 mb-1"
                          ></i>
                        </template>

                        <b-dropdown-item>
                          <span class="btn-block" @click="editUsers(row.item)"
                            ><i class="fas fa-pencil-alt text-info mr-1"></i>
                            {{ $t("button.edit.text") }}</span
                          >
                        </b-dropdown-item>
                        <b-dropdown-item>
                          <span
                            @click="logoutUser(row.item.address)"
                            class="btn-block"
                            ><i
                              class="bx bx-log-in-circle text-primary mr-1"
                            ></i>
                            Log out</span
                          >
                        </b-dropdown-item>

                        <b-dropdown-item>
                          <span
                            @click="deleteuser(row.item.uid)"
                            class="btn-block"
                            ><i class="fas fa-trash-alt text-danger mr-1"></i>
                            {{ $t("button.hapus.text") }}</span
                          >
                        </b-dropdown-item>
                      </b-dropdown>

                      <b-modal
                        ref="ref-modal-edit"
                        :id="'modal-edit' + row.item.uid"
                        centered
                        :title="$t('button.update.text')"
                        title-class="font-17"
                        :ok-title="$t('button.update.text')"
                        :cancel-title="$t('button.cancel.text')"
                      >
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="validationCustom01">{{
                                $t("user-management.phone")
                              }}</label>
                              <input
                                id="validationCustom01"
                                type="text"
                                class="form-control bg-light"
                                :placeholder="
                                  $t('user-management.phone-number')
                                "
                                v-model="form.user.address"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.user.address.$error,
                                }"
                                readonly
                              />
                              <div
                                v-if="submitted && $v.form.user.address.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.user.address.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="validationCustom01">{{
                                $t("user-management.name")
                              }}</label>
                              <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('user-management.name')"
                                v-model="form.user.name"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.user.name.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.form.user.name.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.user.name.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-md-12"
                            v-if="user_type == 'superadmin'"
                          >
                            <div class="form-group">
                              <label for="validationCustom01">{{
                                $t("departments.department")
                              }}</label>
                              <select
                                class="custom-select"
                                v-model="form.user.id_dep"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.user.id_dep.$error,
                                }"
                              >
                                <option
                                  v-for="rg in tableDataDapertement"
                                  :key="rg.id_dep"
                                  :value="rg.id_dep"
                                >
                                  {{ rg.dep_name }}
                                </option>
                              </select>
                              <div
                                v-if="submitted && $v.form.user.id_dep.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.user.id_dep.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <template #modal-footer="{ cancel }">
                          <b-button
                            size="md"
                            variant="danger"
                            @click="cancel()"
                            :class="{ 'disabled ': loading_add }"
                          >
                            {{ $t("button.cancel.text") }}
                          </b-button>
                          <b-button
                            size="md"
                            variant="success"
                            @click="updateUsers($event, row.item)"
                            :class="{ 'disabled ': loading_add }"
                          >
                            <b-spinner
                              variant="light"
                              small
                              v-if="loading_add"
                            ></b-spinner>
                            {{ $t("button.save.text") }}
                          </b-button>
                        </template>
                      </b-modal>
                    </div>
                  </template>
                </b-table>
              </div>

              <div class="row" v-if="tableData.length > 10">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserService from "@/helpers/user.service";
import DepartmentService from "@/helpers/department.service";
import IpConvert from "@/helpers/ipconvert";
import StatistikService from "@/helpers/statistik.service";
import { required, email, sameAs } from "vuelidate/lib/validators";
import store from "@/state/store";
import moment from "moment";

export default {
  page: {
    title: "User Management",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      user_type: "",
      id_dep: "",
      departement: "",
      total_user: 0,
      online_user: 0,
      active_user: 0,
      tableData: [],
      tableDataDapertement: [],
      title: this.$t("user-management.user-management"),
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: this.$t("user-management.user-management"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "prts",
      sortDesc: true,
      form: {
        user: {
          name: "",
          address: "",
          description: "",
          nrp: "",
          id_dep: "",
        },
      },
      loading: false,
      submitted: false,
      loading_add: false,
      loading_active: {
        status: false,
        id: "",
      },
      fields: [
        { key: "prts", sortable: true, thClass: "d-none", tdClass: "d-none" },
        { key: "uid", sortable: true, label: "User ID" },
        { key: "name", sortable: true, label: this.$t("user-management.name") },
        {
          key: "address",
          sortable: true,
          label: this.$t("user-management.phone-number"),
        },
        {
          key: "lastonline",
          sortable: true,
          label: this.$t("user-management.lastonline"),
        },
        {
          key: "ipaddress",
          sortable: true,
          label: this.$t("user-management.ip_address"),
        },
        {
          key: "online",
          sortable: true,
          label: this.$t("user-management.status"),
        },
        {
          key: "action",
          class: "text-center",
          label: this.$t("tables.action"),
        },
      ],
      // mesibo: new Mesibo(),
      // api: "",
    };
  },
  validations: {
    form: {
      user: {
        name: { required },
        address: { required },
        nrp: { required },
        id_dep: { required },
      },
    },
  },

  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  beforeMount() {
    this.userLogin();
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getUser();
    this.totalUser();
    this.totalUserOnline();
    this.totalUserActive();
    // this.initMesibo();
    // this.profile();
  },
  methods: {
    userLogin() {
      UserService.listProfile()
        .then((response) => {
          this.user_type = response.data.data.role;
          this.id_dep = response.data.data.id_dep;
          this.departement = response.data.data.department;
          this.form.user.id_dep = response.data.data.id_dep;
          if (response.data.data.role == "superadmin") {
            this.getDepartements();
          }
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },

    getDepartements() {
      if (this.user_type == "superadmin") {
        DepartmentService.listDepartement()
          .then((response) => {
            this.tableDataDapertement = [];
            this.tableDataDapertement = response.data.data;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },
    // initMesibo() {
    //   this.mesibo.setListener(this.MesiboListener(this.mesibo));
    //   this.mesibo.setAppName("id.seccom.blackphone");
    //   this.mesibo.setCredentials(
    //     "647ab76ac17cc3e8ed545ce06e58aa84c552da94b8211003c5de99426762ta4894e67c73"
    //   );
    //   this.mesibo.start();
    //   // console.log('init');
    // },

    // profile() {
    //   // console.log('prfile =>', this.api.getProfile(1016).getName());
    // },

    // MesiboListener(o) {
    //   this.api = o;
    // },

    totalUser() {
      StatistikService.getTotalUser()
        .then((response) => {
          // console.log(response.data.data);
          this.total_user = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    totalUserOnline() {
      StatistikService.getTotalUserOnline()
        .then((response) => {
          this.online_user = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    totalUserActive() {
      StatistikService.getTotalUserActive()
        .then((response) => {
          this.active_user = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    setActive(item, active) {
      Swal.fire({
        title: active
          ? this.$t("button.active.modal.confirmText[0]")
          : this.$t("button.deactive.modal.confirmText[0]"),
        text: active ? "" : this.$t("button.deactive.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: active
          ? this.$t("button.active.text")
          : this.$t("button.deactive.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading_active.status = true;
          this.loading_active.id = item.uid;
          let data = {
            user: {
              uid: item.uid,
              active: active,
            },
          };

          UserService.editUser(data)
            .then((response) => {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.getUser();
              this.loading_active.status = false;
              this.loading_active.id = "";
            })
            .catch((err) => {
              Vue.swal({
                position: "top-end",
                icon: "error",
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.loading_active.status = false;
              this.loading_active.id = "";
            });
        }
      });
    },

    getUser() {
      this.loading = true;
      UserService.listUser()
        .then((response) => {
          // console.log(response.data.data);
          this.tableData = [];
          this.tableData = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    getUserReload() {
      UserService.listUser()
        .then((response) => {
          this.tableData = [];
          this.tableData = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    addUserModal() {
      this.$bvModal.show("modal-add");
      this.form.user.name = "";
      this.form.user.address = "";
      this.form.user.description = "";
      this.form.user.nrp = "";
      if (this.user_type == "superadmin") {
        this.form.user.id_dep = "";
      }
    },

    addUser(e) {
      this.submitted = true;
      this.$v.form.user.$touch();
      if (
        this.form.user.name == "" ||
        this.form.user.address == "" ||
        this.form.user.nrp == "" ||
        this.form.user.id_dep == ""
      ) {
        e.preventDefault();
      } else {
        this.loading_add = true;
        const data = {
          user: {
            address: this.form.user.address,
            name: this.form.user.name,

            token: {
              appid: process.env.VUE_APP_MESIBO_APPID,
              expiry: 0,
            },

            permissions: {
              incoming: true,
              outgoing: true,
              calls: true,
              turn: true,
              storage: true,
              groupCreate: true,
              retention: true,
              webhook: true,
              peers: "0",
            },

            profile: {
              name: this.form.user.name,
              image: "https://blackphone.xyber.id/picture/default-image.png",
              tn: "",
              status: "User Status 102",
              description: this.form.user.description,
            },

            contact: {
              address: "",
              contact: "",
              subscribe: "",
              pair: "",
              block: "",
              remove: "",
              visibility: "0",
            },
          },
          id_dep: this.form.user.id_dep,
        };

        UserService.addUser(data)
          .then((response) => {
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: "Add User Success",
              showConfirmButton: false,
              timer: 1500,
            });
            this.resetForm();
            this.$v.$reset();
            this.$bvModal.hide("modal-add");
            this.addNRP();
            this.getUserReload();
            this.loading_add = false;
          })
          .catch((err) => {
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: err.response.data.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$v.$reset();
            this.$bvModal.hide("modal-add");
            this.loading_add = false;
          });
      }
    },

    addNRP() {
      this.submitted = true;
      this.$v.form.user.$touch();

      const data = {
        nrp: this.form.user.nrp,
        phone: this.form.user.address,
        info: {
          nrp: this.form.user.nrp,
          nama: "Yusuf Miftah Farid",
          pangkat: "Pratu",
          kesatuan: "Kodam Siliwangi 725/Bandung",
          berlaku: "Ada Perubahan",
          dikeluarkan: "Bandung, 1986-Jul-22",
        },
        id_dep: this.form.user.id_dep,
      };
      // console.log(data);

      UserService.addNrp(data)
        .then((response) => {
          // console.log(response.data.data);
          this.resetForm();
        })
        .catch((err) => {
          console.log(err);
          this.resetForm();
          this.loading_add = false;
        });
    },

    editUsers(data) {
      // console.log(data);
      this.$bvModal.show("modal-edit" + data.uid);
      this.form.user.name = data.profile.name;
      this.form.user.address = data.address;
      this.form.user.description = data.description;
      if (data.dprofile) {
        this.form.user.id_dep = data.dprofile.id_dep;
      }
    },

    updateUsers(e, item) {
      this.submitted = true;
      this.$v.form.user.$touch();
      if (
        this.form.user.name == "" ||
        this.form.user.address == "" ||
        this.form.user.id_dep == ""
      ) {
        e.preventDefault();
      } else {
        this.loading_add = true;
        let data = {
          uid: item.uid,
          user: {
            name: this.form.user.name,
            address: this.form.user.address,
            active: item.active,
            token: {
              appid: process.env.VUE_APP_MESIBO_APPID,
              expiry: 0,
            },

            permissions: {
              incoming: true,
              outgoing: true,
              calls: true,
              turn: true,
              storage: true,
              groupCreate: true,
              retention: true,
              webhook: true,
              peers: "0",
            },

            profile: {
              name: this.form.user.name,
            },
          },
          id_dep: this.form.user.id_dep,
        };
        console.log("data edit", data);
        UserService.editUser(data)
          .then((response) => {
            this.getUserReload();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$bvModal.hide("modal-edit" + item.uid);
            this.resetForm();
            this.$v.$reset();
            this.loading_add = false;
          })
          .catch((err) => {
            Vue.swal({
              position: "top-end",
              icon: "error",
              title: err.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$bvModal.hide("modal-edit" + item.uid);
            this.resetForm();
            this.$v.$reset();
            this.loading_add = false;
          });
      }
    },

    deleteuser(uid) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          const data = {
            user: {
              uid: uid,
            },
          };
          UserService.deleteUser(data)
            .then((response) => {
              this.getUserReload();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            });
        }
      });
    },

    logoutUser(address) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.yes"),
      }).then((result) => {
        if (result.isConfirmed) {
          const data = {
            address: address,
          };
          // console.log(data);
          UserService.logOutUser(data)
            .then((response) => {
              this.getUserReload();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "logout success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "logout failed",
                showConfirmButton: false,
                timer: 1500,
              });
            });
        }
      });
    },

    resetForm() {
      setTimeout(() => {
        (this.form.user.name = ""),
          (this.form.user.phone = ""),
          (this.form.user.description = "");
      }, 2000);
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, HH:mm");
    },

    formatDateTimes(value) {
      var unixTime = value;
      var momentDate = moment.unix(unixTime),
        momentDay = momentDate.format("DD"),
        momentMonth = momentDate.format("MM"),
        momentYear = momentDate.format("YYYY"),
        momentHours = momentDate.format("HH"),
        momentMinutes = momentDate.format("mm"),
        momentSeconds = momentDate.format("ss");

      var t =
        '"' +
        momentYear +
        "-" +
        momentMonth +
        "-" +
        momentDay +
        " " +
        momentHours +
        ":" +
        momentMinutes +
        '"';
      var cdt = moment(t, "YYYY-MM-DD HH:mm");
      let a = this.formatDate(cdt);
      return a;
    },

    ipconvert(value, toDec) {
      if (toDec) {
        return IpConvert.ip2dec(value);
      } else {
        return IpConvert.dec2ip(value);
      }
    },

    acceptNumber(value) {
      let x = value[0];
      if (x == 0) {
        let hasil = x.replace("0", "62");
        let number = value.slice(1, 15);
        return (this.form.user.address = hasil + number);
      }
    },
  },
};
</script>
